module.exports = __webpack_public_path__ + "img/case1.e522809a.png";